import { HelperCore, HelpOther } from '@/common/helper';
import { makeAutoObservable, runInAction } from 'mobx';
import { createSlsLogger } from '@public/log/sls';
import Request from '@src/common/request';
import CreateWcpModal from './';
import Loader from '@/common/helper/loader';
import EE from '@/common/event';
import globalStore from '@/store/global';
import knowledgeChoiceStore from '@/components/knowledge-choice/store';
import clientStore from '@/store/client'
import { request } from 'qiniu-js/esm/utils';
const slsLogger = createSlsLogger('client');

class Store {
  agentImage = '';
  defaultImage = 'https://p0.ssl.qhimg.com/t110b9a930137261518796ffe16.png';
  defaultHoverImage =
    'https://p5.ssl.qhimg.com/t110b9a930142fa62fb6fb54b4d.png';
  currentImage = this.defaultImage;
  mcpList = [];
  modelList = [];
  genLoading = false;
  disableGened = false;
  sunmitLoading = false;
  cloudData = {};
  fields = {
    greeting: '',
    icon: '',
    super_switch: false,
  };
  genCount = 0;
  prompt_form = [];
  KnowledgeList = [];
  form_id = ''
  visiblePromptForm = false

  constructor() {
    makeAutoObservable(this);
    this.init()
  }

  get max_server_count() {
    return this.cloudData?.max_server_count ?? 5;
  }

  get fields() {
    return this.fields;
  }

  get greeting() {
    return this.fields.greeting;
  }

  get icon() {
    return this.fields.icon;
  }

  get server_list() {
    return this.fields.server_list;
  }

  get dataset_id() {
    return this.fields.dataset_id;
  }

  get intro() {
    return this.fields.intro;
  }

  get title() {
    return this.fields.title;
  }

  get saylist_detail() {
    return this.fields.saylist_detail;
  }

  setDisableGened(boolean) {
    runInAction(() => {
      this.disableGened = boolean;
    });
  }

  setFormId(id) {
    runInAction(() => {
      this.form_id = id;
    });
  }

  setDefaultImage = url => {
    runInAction(() => {
      this.currentImage = url;
    });
  };

  setAgentImage(url) {
    this.agentImage = url;
  }

  setGreeting(greeting) {
    runInAction(() => {
      this.fields = {
        ...this.fields,
        greeting,
      };
    });
  }

  setVisiblePromptForm(flag) {
    runInAction(() => {
      this.visiblePromptForm = flag;
    });
  }

  init() {
    this.loadCloudData()
    this.loadMCPlist()
    this.loadModelList()
    knowledgeChoiceStore.loadList(0);
    knowledgeChoiceStore.loadList(1);
  }

  loadKnowledgeList() {

  }

  loadShareKnowledgeList() {

  }

  loadCloudData() {
    Request.get('/config/cloud', {
      params: {
        key: [
          'assistant_mcp_config', // 生视频特效推荐列表
        ].join(','),
      },
    }).then(res => {
      const { data = {} } = res;
      try {
        runInAction(() => {
          this.cloudData = data['assistant_mcp_config']?.map;
        });
      } catch (e) {
        runInAction(() => {
          this.cloudData = {};
        });
      }
    });
  }

  loadMCPlist() {
    Request.get('/ai_agent/mcp/list', {
      params: {
        platform: HelperCore.getOsInfo()?.name,
        version: clientStore.version,
        is_client: clientStore.isLLQ ? 1 :0
      }
    })
      .then(res => {
        runInAction(() => {
          this.mcpList = res.data.map(item => {
            return {
              ...item,
              value: item.server_id,
              label: item.display_name,
            };
          });
        });
      })
      .catch(e => {});
  }

  loadModelList() {
    Request.get('/ai_agent/models', {
      params: {},
    })
      .then(res => {
        runInAction(() => {
          this.modelList = res.data?.list ?? [];
          // this.modelList =  [];
        });
      })
      .catch(e => {});
  }

  getCurrentMcp(id) {
    return this.mcpList.find(item => item.server_id == id);
  }

  createMcp(data) {
    runInAction(() => {
      this.sunmitLoading = true;
    });
    Request.post(
      '/ai_agent/edit',
      {
        ...data,
      },
      { dataIsJson: true }
    )
      .then(res => {
        HelpOther.toast(data.id ? '编辑成功' : '创建成功');
        runInAction(() => {
          this.sunmitLoading = false;
        });
        globalStore.navigate(`/tools/aiagent/mine`);
        EE.emit('AIAgentEdit', data);
      })
      .catch(e => {
        runInAction(() => {
          this.sunmitLoading = false;
        });
        Loader.error(e);
      });
  }

  getMcpDetail(id) {
    return Request.get('/ai_agent/detail', {
      params: {
        id,
      },
    })
      .then(res => {
        let {
          icon,
          greeting,
          server_list,
          dataset_id,
          saylist_detail,
          prompt_list,
          title,
          intro,
          role_id,
          prompt_form = [],
          visitable,
          input_func,
          input_tip
        } = res.data;

        if (!prompt_form) {
          prompt_form = []
        }

        if (input_func) {
          input_func = input_func.split(',')
        }

        runInAction(() => {
          this.agentImage = icon;
          this.agent_type = res.data.agent_type
          this.fields = {
            greeting,
            server_list,
            dataset_id,
            saylist_detail,
            prompt_list,
            title,
            intro,
            role_id,
            prompt_form,
            visitable,
            input_func,
            input_tip
          };
        });
        return this.fields
      })
      .catch(e => {
        HelpOther.toast(e.message, 'error');
        return null;
      });
  }

  isHttpOrHttps(url) {
    return /^https?:\/\//i.test(url);
  }
  setGenLoading(flag) {
    runInAction(() => {
      this.genLoading = flag;
    });
  }
  genFormContent(title, refresh) {
    runInAction(() => {
      this.genLoading = true;
    });
    Request.get('ai_agent/gen_info', {
      params: {
        title,
        timeout: 60000,
      },
    })
      .then(res => {
        runInAction(() => {
          if (res.data) {
            const { greeting } = res?.data;

            if (refresh) {
              if (greeting) {
                this.fields.greeting = greeting;
              }

              if (this.isHttpOrHttps(res.data?.icon)) {
                this.agentImage = res.data?.icon;
              }
            } else {
              if (!this.fields.greeting?.trim()) {
                this.fields.greeting = greeting;
              }

              if (!this.agentImage) {
                if (this.isHttpOrHttps(res.data?.icon)) {
                  this.agentImage = res.data?.icon;
                } else {
                  this.agentImage = this.defaultImage;
                }
              }
            }
          }

          this.genLoading = false;
        });
      })
      .catch(e => {
        HelpOther.toast(e.message, 'error');
        this.genLoading = false;
      });
  }

  getSkillDisableCls(disable, server_list, currentItem) {
    const included = server_list?.includes(currentItem.value);
    if (disable && !included) {
      // 禁用
      return 'disabled';
    }
  }

  getMdelDisableCls(disable, currentItem) {
    if (disable && !currentItem.support_mcp) {
      // 禁用
      return 'disabled';
    }
  }

  resetForm() {
    runInAction(() => {
      this.fields = {};
      this.agentImage = '';
      this.genLoading = false;
      this.disableGened = false;
      this.genCount = 0;
    });
  }
}

const createWcpStore = new Store();
export default createWcpStore;
